// import { useState } from 'react';
// import { OptionButton } from '../../../../../../utils/Button';
// import InstOption from '../../../../../../utils/InstOption';
import { GetDate, GetTime } from '../../../../../../utils/Show';
import cn from '../../../../../../utils/cn';

function TableBodyTr({ item }) {
    // const [showMenu, setShowMenu] = useState(false);
    // const handleShowMenu = () => {
    //     setShowMenu((d) => !d);
    // };

    return (
        <tr
            className={cn('group', {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td>
                <span className="capitalize">{item?.source}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeCreated)}</span>
                <br />
                <span className="text-xs">{GetTime(item?.timeCreated)}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeLogged)}</span>
                <br />
                <span className="text-xs">{GetTime(item?.timeLogged)}</span>
            </td>
            <td className="!text-left">
                <span>{item?.logDetails}</span>
            </td>
            {/* <td className="text-center !pr-4">
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton onClick={handleShowMenu} />
                    <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                        <button type="button">Hide</button>
                    </InstOption>
                </div>
            </td> */}
        </tr>
    );
}

function TableHeader() {
    return (
        <thead>
            <tr className="*:!cursor-default">
                <th scope="col">
                    <span>SL</span>
                </th>
                <th scope="col" className="w-40">
                    <span>Source</span>
                </th>
                <th scope="col" className="w-44 text-center">
                    <span>Create Date & Time</span>
                </th>
                <th scope="col" className="w-44 text-center">
                    <span>Logged Date & Time</span>
                </th>

                <th scope="col" className="!w-full !text-left">
                    <span>Log Description</span>
                </th>

                {/* <th scope="col">#</th> */}
            </tr>
        </thead>
    );
}

function TableWeb({ data }) {
    return (
        <div className="subscriptions_logs_table mb-52">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody>
                    {data?.length === 0 && (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={4} className="!text-left">
                                No Log Found!
                            </td>
                        </tr>
                    )}
                    {data?.map((item) => (
                        <TableBodyTr key={item.id} item={item} />
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
